module.exports = __webpack_public_path__ + "img/t1.4ec87fc9.jpg";